import React from "react";                                       // for JSX & React.useMemo
import { SelectColumnFilter, getFooterSum } from "../InventoryMovementsDetails.js"; 
 
const greenColumnHeaderHighlight = "rgba(0,200,0,.6)";
const redColumnHeaderHighlight   = "rgba(200,0,0,.6)";

export const closingInventory = [
      {
        Header: "Item Id",
        label: "Item Id",
        Footer: "Total :",
        accessor: "item_id",
        value: "item_id",
        width: 120,
      },
      {
        Header: "Item Description || Brand",
        label: "Item Description || Brand",
        accessor: "desc_brand",
        value: "desc_brand",
        width: 220,
      },
      {
         Header: "Category 🔀",
         accessor: "category",
         label: "Category",
         value: "category",
         Filter: SelectColumnFilter,
         filter: (rows, id, filterValue) => {
           // if no category filter, keep all rows
           if (!filterValue) return rows;
     
           // read the current sub-category filter
           const subCat = sessionStorage.getItem("subCategoryFilter") || "All";
     
           return rows.filter(row => {
             const catMatch = row.values[id] === filterValue;
             const subMatch =
               subCat === "All" || row.values.sub_category === subCat;
             return catMatch && subMatch;
           });
         },
         width: 200,
       },
       {
         Header: "Sub Cat",
         accessor: "sub_category",
         label: "Sub Cat",
         value: "sub_category", 
         Filter: SelectColumnFilter,
         filter: (rows, id, filterValue) => {
           if (!filterValue) return rows;
     
           // read the current category filter
           const cat = sessionStorage.getItem("categoryFilter") || "All";
     
           return rows.filter(row => {
             const subMatch = row.values[id] === filterValue;
             const catMatch = cat === "All" || row.values.category === cat;
             return subMatch && catMatch;
           });
         },
     width: 160,
       },

      {
        Header: "Closing Inventory",
        // Footer: (data) => {
        //   const total = React.useMemo(
        //     () => getFooterSum(data, "last_day_closing_inventory"),
        //     [data.rows]
        //   );

        //   return <>{total}</>;
        // },
        Footer: (table) => {
          const total = getFooterSum(table, "closing_inventory");
          return Number(total)?.toLocaleString("en-IN"); // Format total with commas
        },
        label: "Closing Inventory",
        accessor: "closing_inventory",
        value: "closing_inventory",
        width: 160,
        Cell: ({ value }) => {
    const number = Number(value);
    return isNaN(number) ? "N/A" : number.toLocaleString("en-IN");
  },
      },
        {
          Header: "Closing Inventory in KGs 🔀",
          label: "Closing Inventory in KGs",
          Footer: (table) => {
            const total = getFooterSum(table, "resultant_inventory_weight_closing");
            return Number(total)?.toLocaleString("en-IN");
          },
          accessor: "resultant_inventory_weight_closing",
          value: "resultant_inventory_weight_closing",
          disableSortBy: false,
          showSortIndicator: true,
          disableSortRemove: true,
       width: 160,
        },
        {
            Header: "Closing Inventory Value 🔀",
            label: "Closing Inventory Value",
            // Footer: (data) => {
            //   const total = React.useMemo(
            //     () => getFooterSum(data, "inventory_value"),
            //     [data.rows]
            //   );
    
            //   return <>{total}</>;
            // },
            Footer: (table) => {
              const total = getFooterSum(table, "closing_inventory_value");
              return Number(total)?.toLocaleString("en-IN");
            },
            accessor: "closing_inventory_value",
            value: "closing_inventory_value",
            disableSortBy: false,
            showSortIndicator: true,
            disableSortRemove: true,
                width: 160,
          },

      {
        Header: "isActive",
        label: "isActive",
        id: "isActive",
        accessor: "active_status",
        value: "active_status",
        Filter: SelectColumnFilter,
        // filter: "equals",
        filter: (rows, id, filterValue) => {
          if (filterValue === "All" || !filterValue) {
            return rows; // No filtering
          }
          return rows.filter(row => row.values[id] === filterValue); // Apply specific filtering
        },
            width: 160,
      },

    ]